<template>
  <v-main class="pa-0">
    <v-container fluid>
      <v-toolbar class="elevation-0">
        <div class="d-flex align-center">
          <quicksearch v-model="quicksearch"></quicksearch>
        </div>
        <small class="ml-4 text-left">Última atualização:<br/>18/08/2025</small>
        <v-spacer></v-spacer>
        <v-btn :disabled="items.length <= 0" text color="primary" @click="downloadSheet()">
          <v-icon left>mdi-file-excel-outline</v-icon> Baixar planilha
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="filteredItems"
        :no-data-text="noResultText"
        :no-results-text="noResultText"
        loading-text="Carregando..."
        :loading="loading"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn :href="'/documentos/resgate?id=' + item.id" target="_blank" color="primary" fab text small dark>
            <v-icon>mdi-file-document-outline</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.amount="{ item }">
          <span style="white-space: nowrap;">{{ item.amount | price }}</span>
        </template>
        <template v-slot:item.paymentDate="{ item }">
          {{ item.paymentDate | moment('DD/MM/YYYY hh:mm:ss') }}
        </template>
      </v-data-table>
    </v-container>
    <account-modal :accountId="detailsModal" @close="detailsModal = null"></account-modal>
  </v-main>
</template>

<script>
import Quicksearch from '@/components/Quicksearch'
import AccountModal from '@/components/AccountModal'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'

export default {
  name: 'experiences',
  components: {
    Quicksearch,
    AccountModal
  },
  props: {
    accountId: {
      type: String,
      default: null
    }
  },
  data: () => ({
    loading: false,
    quicksearch: '',
    detailsModal: null,
    headers: [
      {
        text: '',
        sortable: false,
        value: 'actions'
      },
      {
        text: 'Gateway',
        value: 'processor'
      },
      {
        text: 'Data',
        value: 'paymentDate'
      },
      {
        text: 'Descrição',
        sortable: false,
        value: 'description'
      },
      {
        text: 'Valor',
        sortable: false,
        value: 'amount',
        align: 'right'
      }
    ],
    pagination: {
      rowsPerPage: 20,
      page: 1,
      total: 0,
      sortBy: [],
      sortDesc: []
    }
  }),
  computed: {
    ...mapGetters(['withdraws']),
    items () {
      if (this.accountId) {
        return this.withdraws(this.accountId).map(e => {
          return {
            id: e._id.$oid,
            processor: (e.processor === 'iugu') ? 'IUGU' : 'MP',
            paymentDate: this.$moment(e.payment_date.$date, 'YYYY-MM-DD[T]HH:mm[.000Z]').format('YYYY-MM-DD HH:mm'),
            description: e.description,
            amount: e.amount
          }
        })
      }
      return []
    },
    noResultText () {
      return 'Nenhum resgate encontrado'
    },
    filteredItems () {
      return this.items.filter(e => {
        return (
          !this.quicksearch ||
          e.processor.toLowerCase().search(this.quicksearch.toLowerCase()) >= 0 ||
          e.paymentDate.toLowerCase().search(this.quicksearch.toLowerCase()) >= 0 ||
          e.description.toLowerCase().search(this.quicksearch.toLowerCase()) >= 0
        )
      })
    }
  },
  methods: {
    downloadSheet () {
      const workbook = XLSX.utils.book_new()
      const collumns = this.headers.filter(e => e.value !== 'actions')
      const dataToDownload = [
        collumns.map(e => e.name),
        ...this.items.map(item => {
          return collumns.map(e => {
            if (e.value === 'paymentDate') return this.$moment(item.paymentDate).format('DD/MM/YYYY hh:mm:ss')
            return item[e.value]
          })
        })
      ]
      const ws = XLSX.utils.aoa_to_sheet(dataToDownload)
      XLSX.utils.book_append_sheet(workbook, ws, 'Resgates')
      XLSX.writeFile(workbook, 'Resgates.xlsx')
    }
  }
}
</script>
